module.exports = __webpack_public_path__ + "img/tutorial-f02-01.6a1d7fbd.png";